"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    container: {
      flexGrow: 1,
      position: 'relative'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
      minWidth: 'max-content'
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    inputRoot: {
      flexWrap: 'wrap',
      backgroundColor: theme.palette.white.main
    },
    inputInput: {
      width: 'auto',
      flexGrow: 1
    },
    addNew: {
      color: theme.palette.primary.main
    },
    bold: {
      fontWeight: 900
    },
    to: {
      marginRight: theme.spacing(2)
    },
    selected: {
      marginRight: theme.spacing(2),
      lineHeight: '34px'
    }
  };
};

exports["default"] = _default;